// @core/api/endpoints/attachment/delete_attachment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/attachment';

/**
 * Delete attachment
 * Removes an attachment and its associated file from storage. Supports both soft delete (recoverable) and hard delete (permanent) options.
 */
export async function DeleteAttachment(
  attachment_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/attachments/:attachment_id`;
  requestPath = requestPath.replace(':attachment_id', encodeURIComponent(attachment_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
